import React, {createContext, useContext, useState, useEffect} from 'react';
import {translations} from '../data/translations';

const LanguageContext = createContext();

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};

export const LanguageProvider = ({children}) => {
  const [language, setLanguage] = useState(() => {
    try {
      const savedLanguage = localStorage.getItem('language');
      return savedLanguage && translations[savedLanguage] ? savedLanguage : 'es';
    } catch (error) {
      console.warn('Error accessing localStorage:', error);
      return 'es';
    }
  });

  useEffect(() => {
    try {
      localStorage.setItem('language', language);
    } catch (error) {
      console.warn('Error saving to localStorage:', error);
    }
  }, [language]);

  const t = (key) => {
    try {
      return translations[language]?.[key] || translations.es?.[key] || key;
    } catch (error) {
      console.warn('Translation error:', error);
      return key;
    }
  };

  const changeLanguage = (newLanguage) => {
    if (translations[newLanguage]) {
      setLanguage(newLanguage);
    }
  };

  return (
    <LanguageContext.Provider value={{language, changeLanguage, t}}>
      {children}
    </LanguageContext.Provider>
  );
};